<template>
  <div class="content">
    <!-- 标题 -->
    <div class="title">{{ $t("label.stdashbord.xsld.business.role") }}</div>
    <!-- 角色树 -->
    <div class="roleTree">
      <el-tree
        default-expand-all="true"
        node-key="id"
        ref="tree"
        v-loading="loading"
        @check="checkTree"
        :data="roleData"
        show-checkbox
        check-strictly="true"
        :props="defaultProps"
        :default-checked-keys="checkedKeys"
      ></el-tree>
    </div>
    <!-- 按钮组 -->
    <div slot="footer" class="buttom-button">
      <div class="button submit" @click="submitMessage">
        {{ $t("label.confirm") }}
      </div>
      <div class="button" @click="cancel">{{ $t("label.cancel") }}</div>
    </div>
  </div>
</template>

<script>
/**
 * @description: 角色树
 * 功能：
 * 1、角色树
 * 2、选中/取消选中数据
 * 3、确认选择
 * 逻辑：
 * 1、根据传入的数据展示角色树
 * 2、自定义选中、取消选中事件,当选中节点有子节点时,只选中当前节点和其子节点,不影响其他节点状态
 * 3、获取选中数据并传到父组件
 */

export default {
  props: {
    /**
     * 是否loading
     */
    loading:{
      type: Boolean,
      default: false
    },
    /**
     * 可选数据
     */
    roleData: {
      type: Array,
      default: () => [],
    },
    /**
     * 控制是否清空选中数据
     */
    roleName: {
      type: String,
      default: "",
    },
    /**
     * 已选中数据id集合
     */
    checkedKeys: {
      type: Array,
      default: () => [],
    },
    /**
     * 自定义树属性信息
     */
    defaultProps: {
      type: Object,
      default: () => ({
        children: "children",
        label: "label",
      }),
    },
  },
  data() {
    return {
      selectedRole: [], // 选中的角色列表
      selectedUser: [], // 选中的用户列表
    };
  },
  methods: {
    /**
     * 获取当前选中的节点,设置其子节点选中状态
     * @param {data} 选中的节点数据
     */
    checkTree(data) {
      //获取当前选中的节点
      let node = this.$refs.tree.getNode(data.id);
      this.checkChild(node);
    },
    /**
     * 根据传入父节点信息,设置子节点选中状态
     * @param {node} 父节点数据
     */
    checkChild(node) {
      //  如果是父节点 并且被选中
      if (node.childNodes.length !== 0) {
        node.childNodes.forEach((item, index, array) => {
          array[index].checked = node.checked;
          this.checkChild(array[index]);
        });
      }
    },
    /**
     * 取消选中数据
     */
    cancel() {
      this.$emit("cancel", false);
    },
    /**
     * 确认选中数据，并将选中树节点信息传给父组件
     */
    submitMessage() {
      //获取选中的所有节点
      let result = this.$refs.tree.getCheckedKeys();
      this.$emit("deliverLength", result);
      this.$emit("cancel", false);
    },
  },
  watch: {
    /**
     * 根据传入的数据对节点进行选中处理
     */
    roleName(val) {
      if (val == "") {
        let result = this.$refs.tree.getCheckedKeys();
        result.map((item, index) => {
          let ele = this.$refs.tree.getNode(item);
          ele.checked = false;
        });
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.content {
  width: 100%;
}
.tltle {
  font-family: SourceHanSansCN-Medium;
  font-size: 12px;
  color: #080707;
}
.roleTree {
  margin: 20px 0px;
  padding-bottom: 40px;
  max-height: 500px;
  overflow-y: auto;
}
.buttom-button {
  border-top: 1px solid #d9d9d9;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 45px;
  background: #f4f6f9;
  border-radius: 3px;
  padding: 12px;
  z-index: 2;
}
.button {
  cursor: pointer;
  width: 54px;
  height: 25px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #dcdcdc;
  float: right;
  line-height: 25px;
  text-align: center;
  margin-right: 10px;
  font-size: 12px;
}
.submit {
  border: none;
  background: #1b5297;
  color: white;
}
</style>